import { FC } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";

interface BatInsightsProps {
	stats: Record<string, string | number | null>[];
	selectedBatters: string[];
	stat: string;
}

const palette = [
	"#30c5ff",
	"#22c55e",
	"#f59e0b",
	"#fb7185",
	"#a78bfa",
	"#14b8a6",
	"#ef4444",
	"#94a3b8"
];

const getColorForName = (name: string) => {
	const hash = name.split("").reduce((acc, char) => acc + char.charCodeAt(0), 0);
	return palette[hash % palette.length];
};

const InsightGraph: FC<BatInsightsProps> = ({ stats, selectedBatters, stat }) => {
	return (
		<div className="h-[360px] md:h-[430px] p-2 md:p-4">
			<ResponsiveContainer width="100%" height="100%">
				<LineChart
					className="mt-2"
					data={stats}
					margin={{
						top: 12,
						right: 24,
						left: 8,
						bottom: 8
					}}
				>
					<XAxis dataKey="name" stroke="#94a3b8" />
					<YAxis
						label={{ value: stat, angle: -90, position: "insideLeft", fill: "#94a3b8" }}
						stroke="#94a3b8"
					/>
					<Tooltip contentStyle={{ background: "#0f172a", border: "1px solid #334155" }} />
					<Legend />
					{selectedBatters.map(batter => {
						const color = getColorForName(batter);
						return (
							<Line
								fill={color}
								key={batter}
								type="monotone"
								dataKey={batter}
								stroke={color}
								strokeWidth={3}
								activeDot={{ r: 7 }}
								connectNulls
							/>
						);
					})}
				</LineChart>
			</ResponsiveContainer>
		</div>
	);
};

export default InsightGraph;
